import { lazy, Suspense } from "react";
import { SubHeading } from "../Components";

const BadlaRateBody = lazy(() => import("./BadlaRateBody"));

const BadlaRate = () => {
  return (
    <>
      <SubHeading subTitle="Badla rate" />

      <Suspense fallback={<>Loading</>}>
        <BadlaRateBody />
      </Suspense>
    </>
  );
};

export default BadlaRate;
